import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const CommunityAiComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "CommunityAiPage" */ "@circle-react/components/SettingsApp/CommunityAi"
    ),
);

export const CommunityAiPage = () => (
  <Suspense fallback={<PageLoader />}>
    <CommunityAiComponent />
  </Suspense>
);
